import { ThemeConfig } from "./themeTypes";

export const defaultThemeConfig: ThemeConfig = {
  brand: {
    brandName: "RedCapital",
    logoUrl: "/images/logo-redcapital-head.png",
    faviconUrl: "/favicon.ico",
    ogImage: "/favicon.ico",
    contactMail: "contacto@redcapital.cl",
    metaDescription: "Plataforma digital de financiamiento para Pymes",
    metaKeywords: "factoring, financiamiento, pymes, anticipo facturas",
    ogUrl: "https://redcapital.cl/",
    termsUrl: null,
    definitionsUrl: null,
    landingDecoUrl: null
  },
  colors: {
    primary:       "#ff8a00",
    primaryHover:  "#fd773f",
    primaryActive: "#ec6b1c",
    secondary:     "#951836",
    background:    "#ffffff",
    surface:       "#f8f8f8",
    text:          "#3d3d3d",
    textMuted:     "#8b8b8b",
    border:        "#e8e8e8",
    success:       "#00d1a8",
    warning:       "#F7931E",
    danger:        "#E25A43",
    info:          "#11ADD2",
    onPrimary:     "#ffffff",
    onSurface:     "#3d3d3d"
  },
  recaptchaSiteKey: null,
  gtmId: null,
  googleAnalyticsId: null,
  hotjarId: null,
  accessMode: "full"
};
